const getLinkFromAbsolutePath = absolutePath =>
  absolutePath
    .split('/pages')[1]
    .replace('.mdx', '')
    .replace('index', '');

export default getLinkFromAbsolutePath;
